import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoginModel } from '../model/login.model';
import { LocalStorageService } from "./localstorage.service";


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  public logado: boolean = false;
  private loginURL: string = 'api/login/login';
  private validateURL: string = 'api/login/validate';

  public loginModel: LoginModel | undefined;

  public msgSessaoExpirada = 'Sessão expirada. Favor logar novamente no sistema.';

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService

  ) { }



  getLogin(guid: string): Promise<LoginModel> {
    return new Promise<LoginModel>((resolve, reject) => {
      this.http.get<LoginModel>(environment.host_ctf_service + this.loginURL + '?userGuid=' + guid)
        .subscribe({
          complete: () => {
            //console.log('complete');
          },
          error: (erro) => {
            reject(erro);
          },
          next: (data: LoginModel) => {
            //console.log('next: ');
            resolve(data);
          }
        });
    })
  }

  getDadosUserLocal(): LoginModel {
    var userData = this.localStorageService.getItem('userData');

    if (userData != null) {
      this.loginModel = (JSON.parse(userData)) as LoginModel;
      return this.loginModel;
    }
    return (JSON.parse("sucesso: false")) as LoginModel;
  }
  // Método Validate realizando uma chamada mais leve que o login apenas para validar se o Guid ainda está ativo

  validate(guid: string): Promise<LoginModel> {
    return new Promise<LoginModel>((resolve, reject) => {
      this.http.get<LoginModel>(environment.host_ctf_service + this.validateURL + '?userGuid=' + guid)
        .subscribe({
          complete: () => {
          },
          error: (erro) => {
            reject(erro);
          },
          next: (data: LoginModel) => {
            resolve(data);
          }
        });
    })
  }

  async mockLocalstorage(guidMock: string) {

    sessionStorage.setItem("filtroSubFrota", JSON.stringify({ "guid": guidMock, "uf": "", "flagCentroCusto": "" }));

    this.localStorageService.setItem(
      'userData',
      JSON.stringify({
        retorno: {
          guid: guidMock,
          codigoAcesso: 41490,
          codigoEntidade: 2,
          codigoUsuario: 35312,
          nome: 'FROTA8563',
          nomeFantasia: 'CTF-MATRIZ',
          login: 'frota8563',
          tipo: 2,
          caminhoneiro: false,
          tipoCaminhoneiro: null,
          uuid: null,
          uFs: null,
          modoOperacao: null,
          codRodocred: 0,
          menu: null,
          appAbast: false,
          combustivelPadrao: 0,
          textos: null,
          celular: '11-38374200',
          firebaseTokenUsuario: null,
          entidades: null,
          redes: null,
          appDestino: null,
          bancoAtual: null,
          aparencia: 'PADRAO',
          email: 'patricia.chapetta@feeltcor.com.br',
          loginDbtrans: null,
          perfis: null,
          permissoes: [
            {
              codigoPermissao: 11,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 12,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 14,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 23,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 24,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 27,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 40,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 41,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 56,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 57,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 58,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 59,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 61,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 62,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 63,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 64,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 66,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 70,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 71,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 73,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 74,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 75,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 82,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 83,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 84,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 85,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 86,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 87,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 88,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 89,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 98,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 101,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 108,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 109,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 171,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 182,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 195,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 228,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 415,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 416,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 419,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 503,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 515,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 526,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 527,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 528,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 687,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 740,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 800,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 803,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 810,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1093,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1094,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1095,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1187,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1344,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1398,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1408,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1409,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1416,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1426,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1430,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1431,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1432,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1435,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1436,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1437,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1438,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1439,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1440,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1441,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1442,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1444,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1449,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1452,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1471,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1472,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1473,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1474,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1476,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1477,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1478,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1479,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1480,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1485,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1492,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1567,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1568,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1569,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1570,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1571,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1588,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1589,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1592,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1593,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1604,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1605,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1607,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1608,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1616,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1619,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1623,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1624,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1625,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1663,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1672,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1673,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1676,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1687,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1688,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1689,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1690,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1692,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1693,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1694,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1695,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1697,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1698,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1722,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1737,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1751,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1756,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1765,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1766,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1782,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1809,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 1878,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2035,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2042,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2061,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2062,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2063,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2072,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2159,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2160,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2162,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2166,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2178,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2180,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2188,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2213,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2214,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2242,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2243,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2246,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2247,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2257,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2263,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2266,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2269,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2270,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2271,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2283,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2284,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2289,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2290,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2293,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2294,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2297,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2298,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2299,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2300,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2301,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2302,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2310,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2317,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2320,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2322,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2323,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2324,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2325,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2327,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2329,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2332,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2335,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2337,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2340,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2368,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2376,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2377,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2379,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2381,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2383,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2385,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2386,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2387,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2388,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2389,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2390,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2391,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2392,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2393,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2394,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2395,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2397,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2398,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2399,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2400,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2401,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2402,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2408,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2410,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2411,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2412,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2413,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2415,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2426,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2432,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2433,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2434,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2437,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2438,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2441,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2442,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2443,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
            {
              codigoPermissao: 2444,
              dscPermissao: null,
              codigoMenu: 0,
              dscIcon: null,
              isHomePage: false,
              isAtalho: false,
              codigoOrdemAtalho: 0,
            },
          ],
          ativacao: null,
        },
        sucesso: true,
        mensagens: [],
      })
    );


    this.localStorageService.setItem(
      'postosAPI',
      JSON.stringify([
        {
          Fantasia: '2794 - VIDEIRA',
          Combustiveis: [],
          Latitude: -23.14571,
          Longitude: -46.93881,
          ComAcordo: false,
        },
        {
          Fantasia: '3487 - CAMPEAO 38',
          Combustiveis: [],
          Latitude: -23.33362,
          Longitude: -46.82328,
          ComAcordo: false,
        },
        {
          Fantasia: '10645 - AUTO POSTO CAPELA - VINHEDO',
          Combustiveis: [],
          Latitude: -23.04238,
          Longitude: -47.00653,
          ComAcordo: false,
        },
        {
          Fantasia: '14203 - AUTO POSTO SACI LTDA',
          Combustiveis: [],
          Latitude: -22.99518,
          Longitude: -47.03498,
          ComAcordo: false,
        },
      ])
    );

    this.localStorageService.setItem('guid', JSON.stringify(guidMock));


  }


}
